/*@flow*/
/** @jsx jsx */
import {
  Route,
  Redirect,
  Switch,
  Link,
  type ContextRouter,
} from 'react-router-dom';
import Router from 'comps/App/Router';
import QuerySync from 'comps/App/QuerySync';
import DataSync from 'comps/App/DataSync';
import { jsx, css } from '@emotion/core';
import { useEffect } from 'react';
// ----- Pages -----
import Home from 'comps/Pages/Home';
import Dashboard from 'comps/Pages/Dashboard';
// $FlowFixMe
import { ReactComponent as Symbols } from 'images/symbols.svg';
import hash from 'lib/hash';
import * as commands from 'store/commands';
import qs from 'qs';
const getLocation = props => {
  return props.location.pathname + '?' + qs.stringify(props.location.query);
};

const PAGE_TITLE = 'The Circular City | Downtown Brooklyn Dashboard';

const App = (props: ContextRouter) => {
  useEffect(() => {
    commands.setupGA();
  }, []);

  useEffect(() => {
    const el = document.querySelector('title');
    if (el) {
      el.innerText = PAGE_TITLE;
    }
    commands.sendPageView({ page_location: getLocation(props) });
  }, [props.location.pathname, hash(props.location.query)]);

  return (
    <div
      className="App"
      css={css(`
      @font-face {
        font-family: Akzidenz;
        src: url('${(process.env: any).PUBLIC_URL}/fonts/Akzidenz Regular.otf');
      }
      @font-face {
        font-family: Akzidenz;
        src: url('${(process.env: any).PUBLIC_URL}/fonts/Akzidenz Bold.otf');
        font-weight: bold;
      }
      font-family: Akzidenz, sans-serif;
  `)}
    >
      {process.env.__DEV__ && <QuerySync queryPath="ui" storePath="ui" />}
      <DataSync namespace="__circular__" storePath="Cache" />
      <Switch>
        <Route exact path="/" component={Home} />
        <Route exact path="/dashboard" component={Dashboard} />
        <Route
          exact
          path="/value-of-data"
          render={() => <Redirect to="/dashboard" />}
        />
        <Route component={NoMatch} />
      </Switch>
    </div>
  );
};

const NoMatch = props => (
  <div className="container" style={{ padding: 20 }}>
    <h3>
      No match for <code>{props.location.pathname}</code>
    </h3>
    <p>
      <Link style={{ color: 'blue' }} to="/">
        Go home
      </Link>
    </p>
  </div>
);

export default () => (
  <Router>
    <Route path="/" component={App} />
    <Symbols />
  </Router>
);
